"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { NftPageStats } from "@/components/nft-attributes/NftStats";
import RememeImage from "@/components/nft-image/RememeImage";
import NFTMarketplaceLinks from "@/components/nft-marketplace-links/NFTMarketplaceLinks";
import Pagination from "@/components/pagination/Pagination";
import { printMemeReferences } from "@/components/rememes/RememePage";
import { RememeSort } from "@/components/rememes/Rememes";
import { publicEnv } from "@/config/env";
import { OPENSEA_STORE_FRONT_CONTRACT } from "@/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { MemesExtendedData, NFT, Rememe } from "@/entities/INFT";
import { areEqualAddresses, formatAddress, numberWithCommas, printMintDate } from "@/helpers/Helpers";
import useCapacitor from "@/hooks/useCapacitor";
import { fetchUrl } from "@/services/6529api";
import { faFire, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Col, Container, Dropdown, Row, Table } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import ArtistProfileHandle from "./ArtistProfileHandle";
import MemeCalendarPeriods from "./MemeCalendarPeriods";
import styles from "./TheMemes.module.scss";
const REMEMES_PAGE_SIZE = 20;
export function MemePageLiveRightMenu(props) {
  const $ = _c(129);
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  let t0;
  bb0: {
    const id = props.nft?.id;
    if (!id) {
      t0 = "";
      break bb0;
    }
    if (props.nft?.has_distribution) {
      t0 = `/the-memes/${id}/distribution`;
      break bb0;
    }
    if (id > 3) {
      t0 = `https://github.com/6529-Collections/thememecards/tree/main/card${id}`;
      break bb0;
    }
    t0 = "https://github.com/6529-Collections/thememecards/tree/main/card1-3";
  }
  const distributionPlanLink = t0;
  if (props.show && props.nft && props.nftMeta) {
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        span: 12
      };
      t2 = {
        span: 12
      };
      t3 = {
        span: 6
      };
      t4 = {
        span: 6
      };
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
      $[3] = t4;
    } else {
      t1 = $[0];
      t2 = $[1];
      t3 = $[2];
      t4 = $[3];
    }
    let t5;
    if ($[4] !== props.nft.id) {
      t5 = <Row><Col><MemeCalendarPeriods id={props.nft.id} /></Col></Row>;
      $[4] = props.nft.id;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Row className="pt-2"><Col><h3>Meme Collectors</h3></Col></Row>;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <td>Edition Size</td>;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== props.nftMeta.edition_size) {
      t8 = numberWithCommas(props.nftMeta.edition_size);
      $[8] = props.nftMeta.edition_size;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== t8) {
      t9 = <td className="text-right">{t8}</td>;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    let t10;
    if ($[12] !== props.nftMeta.collection_size || $[13] !== props.nftMeta.edition_size_rank) {
      t10 = <td className="text-right">{props.nftMeta.edition_size_rank}/{props.nftMeta.collection_size}</td>;
      $[12] = props.nftMeta.collection_size;
      $[13] = props.nftMeta.edition_size_rank;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    let t11;
    if ($[15] !== t10 || $[16] !== t9) {
      t11 = <tr>{t7}{t9}{t10}</tr>;
      $[15] = t10;
      $[16] = t9;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] !== props.nftMeta.burnt || $[19] !== props.nftMeta.collection_size || $[20] !== props.nftMeta.edition_size_not_burnt || $[21] !== props.nftMeta.edition_size_not_burnt_rank) {
      t12 = props.nftMeta.burnt > 0 && <><tr><td><span className="d-flex align-items-center gap-2"><span>Burnt</span><FontAwesomeIcon icon={faFire} style={{
                height: "22px",
                color: "#c51d34"
              }} /></span></td><td className="text-right">{numberWithCommas(props.nftMeta.burnt)}</td></tr><tr><td>Edition Size ex. Burnt</td><td className="text-right">{numberWithCommas(props.nftMeta.edition_size_not_burnt)}</td><td className="text-right">{props.nftMeta.edition_size_not_burnt_rank}/{props.nftMeta.collection_size}</td></tr></>;
      $[18] = props.nftMeta.burnt;
      $[19] = props.nftMeta.collection_size;
      $[20] = props.nftMeta.edition_size_not_burnt;
      $[21] = props.nftMeta.edition_size_not_burnt_rank;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <td>6529 Museum</td>;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    let t14;
    if ($[24] !== props.nftMeta.museum_holdings) {
      t14 = numberWithCommas(props.nftMeta.museum_holdings);
      $[24] = props.nftMeta.museum_holdings;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== t14) {
      t15 = <td className="text-right">{t14}</td>;
      $[26] = t14;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    if ($[28] !== props.nftMeta.collection_size || $[29] !== props.nftMeta.museum_holdings_rank) {
      t16 = <td className="text-right">{props.nftMeta.museum_holdings_rank}/{props.nftMeta.collection_size}</td>;
      $[28] = props.nftMeta.collection_size;
      $[29] = props.nftMeta.museum_holdings_rank;
      $[30] = t16;
    } else {
      t16 = $[30];
    }
    let t17;
    if ($[31] !== t15 || $[32] !== t16) {
      t17 = <tr>{t13}{t15}{t16}</tr>;
      $[31] = t15;
      $[32] = t16;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    const t18 = props.nftMeta.burnt > 0 && " Burnt and";
    let t19;
    if ($[34] !== t18) {
      t19 = <td>Edition Size ex.{t18}{" "}6529 Museum</td>;
      $[34] = t18;
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    let t20;
    if ($[36] !== props.nftMeta.edition_size_cleaned) {
      t20 = numberWithCommas(props.nftMeta.edition_size_cleaned);
      $[36] = props.nftMeta.edition_size_cleaned;
      $[37] = t20;
    } else {
      t20 = $[37];
    }
    let t21;
    if ($[38] !== t20) {
      t21 = <td className="text-right">{t20}</td>;
      $[38] = t20;
      $[39] = t21;
    } else {
      t21 = $[39];
    }
    let t22;
    if ($[40] !== props.nftMeta.collection_size || $[41] !== props.nftMeta.edition_size_cleaned_rank) {
      t22 = <td className="text-right">{props.nftMeta.edition_size_cleaned_rank}/{props.nftMeta.collection_size}</td>;
      $[40] = props.nftMeta.collection_size;
      $[41] = props.nftMeta.edition_size_cleaned_rank;
      $[42] = t22;
    } else {
      t22 = $[42];
    }
    let t23;
    if ($[43] !== t19 || $[44] !== t21 || $[45] !== t22) {
      t23 = <tr>{t19}{t21}{t22}</tr>;
      $[43] = t19;
      $[44] = t21;
      $[45] = t22;
      $[46] = t23;
    } else {
      t23 = $[46];
    }
    let t24;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <td>Collectors</td>;
      $[47] = t24;
    } else {
      t24 = $[47];
    }
    let t25;
    if ($[48] !== props.nftMeta.hodlers) {
      t25 = numberWithCommas(props.nftMeta.hodlers);
      $[48] = props.nftMeta.hodlers;
      $[49] = t25;
    } else {
      t25 = $[49];
    }
    let t26;
    if ($[50] !== t25) {
      t26 = <td className="text-right">{t25}</td>;
      $[50] = t25;
      $[51] = t26;
    } else {
      t26 = $[51];
    }
    let t27;
    if ($[52] !== props.nftMeta.collection_size || $[53] !== props.nftMeta.hodlers_rank) {
      t27 = <td className="text-right">{props.nftMeta.hodlers_rank}/{props.nftMeta.collection_size}</td>;
      $[52] = props.nftMeta.collection_size;
      $[53] = props.nftMeta.hodlers_rank;
      $[54] = t27;
    } else {
      t27 = $[54];
    }
    let t28;
    if ($[55] !== t26 || $[56] !== t27) {
      t28 = <tr>{t24}{t26}{t27}</tr>;
      $[55] = t26;
      $[56] = t27;
      $[57] = t28;
    } else {
      t28 = $[57];
    }
    let t29;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = <td>% Unique</td>;
      $[58] = t29;
    } else {
      t29 = $[58];
    }
    const t30 = Math.round(props.nftMeta.percent_unique * 100 * 10) / 10;
    let t31;
    if ($[59] !== t30) {
      t31 = <td className="text-right">{t30}%</td>;
      $[59] = t30;
      $[60] = t31;
    } else {
      t31 = $[60];
    }
    let t32;
    if ($[61] !== props.nftMeta.collection_size || $[62] !== props.nftMeta.percent_unique_rank) {
      t32 = <td className="text-right">{props.nftMeta.percent_unique_rank}/{props.nftMeta.collection_size}</td>;
      $[61] = props.nftMeta.collection_size;
      $[62] = props.nftMeta.percent_unique_rank;
      $[63] = t32;
    } else {
      t32 = $[63];
    }
    let t33;
    if ($[64] !== t31 || $[65] !== t32) {
      t33 = <tr>{t29}{t31}{t32}</tr>;
      $[64] = t31;
      $[65] = t32;
      $[66] = t33;
    } else {
      t33 = $[66];
    }
    let t34;
    if ($[67] !== props.nftMeta.burnt || $[68] !== props.nftMeta.collection_size || $[69] !== props.nftMeta.percent_unique_not_burnt || $[70] !== props.nftMeta.percent_unique_not_burnt_rank) {
      t34 = props.nftMeta.burnt > 0 && <tr><td>% Unique ex. Burnt</td><td className="text-right">{Math.round(props.nftMeta.percent_unique_not_burnt * 100 * 10) / 10}%</td><td className="text-right">{props.nftMeta.percent_unique_not_burnt_rank}/{props.nftMeta.collection_size}</td></tr>;
      $[67] = props.nftMeta.burnt;
      $[68] = props.nftMeta.collection_size;
      $[69] = props.nftMeta.percent_unique_not_burnt;
      $[70] = props.nftMeta.percent_unique_not_burnt_rank;
      $[71] = t34;
    } else {
      t34 = $[71];
    }
    const t35 = props.nftMeta.burnt > 0 && " Burnt and";
    let t36;
    if ($[72] !== t35) {
      t36 = <td>% Unique ex.{t35} 6529 Museum</td>;
      $[72] = t35;
      $[73] = t36;
    } else {
      t36 = $[73];
    }
    const t37 = Math.round(props.nftMeta.percent_unique_cleaned * 100 * 10) / 10;
    let t38;
    if ($[74] !== t37) {
      t38 = <td className="text-right">{t37}%</td>;
      $[74] = t37;
      $[75] = t38;
    } else {
      t38 = $[75];
    }
    let t39;
    if ($[76] !== props.nftMeta.collection_size || $[77] !== props.nftMeta.percent_unique_cleaned_rank) {
      t39 = <td className="text-right">{props.nftMeta.percent_unique_cleaned_rank}/{props.nftMeta.collection_size}</td>;
      $[76] = props.nftMeta.collection_size;
      $[77] = props.nftMeta.percent_unique_cleaned_rank;
      $[78] = t39;
    } else {
      t39 = $[78];
    }
    let t40;
    if ($[79] !== t36 || $[80] !== t38 || $[81] !== t39) {
      t40 = <tr>{t36}{t38}{t39}</tr>;
      $[79] = t36;
      $[80] = t38;
      $[81] = t39;
      $[82] = t40;
    } else {
      t40 = $[82];
    }
    let t41;
    if ($[83] !== t11 || $[84] !== t12 || $[85] !== t17 || $[86] !== t23 || $[87] !== t28 || $[88] !== t33 || $[89] !== t34 || $[90] !== t40) {
      t41 = <Row><Col><Table bordered={false} className={styles.hodlersTableLive}><tbody>{t11}{t12}{t17}{t23}{t28}{t33}{t34}{t40}</tbody></Table></Col></Row>;
      $[83] = t11;
      $[84] = t12;
      $[85] = t17;
      $[86] = t23;
      $[87] = t28;
      $[88] = t33;
      $[89] = t34;
      $[90] = t40;
      $[91] = t41;
    } else {
      t41 = $[91];
    }
    let t42;
    if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = <Row className="pt-3"><Col><h3>NFT</h3></Col></Row>;
      $[92] = t42;
    } else {
      t42 = $[92];
    }
    let t43;
    if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
      t43 = <td>Artist Name</td>;
      $[93] = t43;
    } else {
      t43 = $[93];
    }
    let t44;
    if ($[94] !== props.nft.artist) {
      t44 = <tr>{t43}<td>{props.nft.artist}</td></tr>;
      $[94] = props.nft.artist;
      $[95] = t44;
    } else {
      t44 = $[95];
    }
    let t45;
    if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
      t45 = <td>Artist Profile</td>;
      $[96] = t45;
    } else {
      t45 = $[96];
    }
    let t46;
    if ($[97] !== props.nft) {
      t46 = <tr>{t45}<td><ArtistProfileHandle nft={props.nft} /></td></tr>;
      $[97] = props.nft;
      $[98] = t46;
    } else {
      t46 = $[98];
    }
    let t47;
    if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = <td>Mint Date</td>;
      $[99] = t47;
    } else {
      t47 = $[99];
    }
    let t48;
    if ($[100] !== props.nft.mint_date) {
      t48 = printMintDate(props.nft.mint_date);
      $[100] = props.nft.mint_date;
      $[101] = t48;
    } else {
      t48 = $[101];
    }
    let t49;
    if ($[102] !== t48) {
      t49 = <tr>{t47}<td>{t48}</td></tr>;
      $[102] = t48;
      $[103] = t49;
    } else {
      t49 = $[103];
    }
    let t50;
    if ($[104] !== props.nft) {
      t50 = <NftPageStats nft={props.nft} />;
      $[104] = props.nft;
      $[105] = t50;
    } else {
      t50 = $[105];
    }
    let t51;
    if ($[106] !== t44 || $[107] !== t46 || $[108] !== t49 || $[109] !== t50) {
      t51 = <Row><Col><Table bordered={false}><tbody>{t44}{t46}{t49}{t50}</tbody></Table></Col></Row>;
      $[106] = t44;
      $[107] = t46;
      $[108] = t49;
      $[109] = t50;
      $[110] = t51;
    } else {
      t51 = $[110];
    }
    let t52;
    if ($[111] !== distributionPlanLink || $[112] !== props.nft.has_distribution) {
      t52 = distributionPlanLink && <Row><Col><Link href={distributionPlanLink} target={props.nft.has_distribution ? "_self" : "_blank"} rel={props.nft.has_distribution ? undefined : "noopener noreferrer"}>Distribution Plan</Link></Col></Row>;
      $[111] = distributionPlanLink;
      $[112] = props.nft.has_distribution;
      $[113] = t52;
    } else {
      t52 = $[113];
    }
    let t53;
    if ($[114] !== props.nftBalance) {
      t53 = props.nftBalance > 0 && <Row className="pt-3"><Col><h3 className="font-color">You Own {props.nftBalance} edition{props.nftBalance > 1 && "s"}</h3></Col></Row>;
      $[114] = props.nftBalance;
      $[115] = t53;
    } else {
      t53 = $[115];
    }
    let t54;
    if ($[116] !== capacitor.isIos || $[117] !== country || $[118] !== props.nft.contract || $[119] !== props.nft.id) {
      t54 = (!capacitor.isIos || country === "US") && <Row className="pt-4"><Col><NFTMarketplaceLinks contract={props.nft.contract} id={props.nft.id} /></Col></Row>;
      $[116] = capacitor.isIos;
      $[117] = country;
      $[118] = props.nft.contract;
      $[119] = props.nft.id;
      $[120] = t54;
    } else {
      t54 = $[120];
    }
    let t55;
    if ($[121] !== t41 || $[122] !== t5 || $[123] !== t51 || $[124] !== t52 || $[125] !== t53 || $[126] !== t54) {
      t55 = <Col xs={t1} sm={t2} md={t3} lg={t4} className="pt-2"><Container className="p-0">{t5}{t6}{t41}{t42}{t51}{t52}{t53}{t54}</Container></Col>;
      $[121] = t41;
      $[122] = t5;
      $[123] = t51;
      $[124] = t52;
      $[125] = t53;
      $[126] = t54;
      $[127] = t55;
    } else {
      t55 = $[127];
    }
    return t55;
  } else {
    let t1;
    if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[128] = t1;
    } else {
      t1 = $[128];
    }
    return t1;
  }
}
export function MemePageLiveSubMenu(props: {
  show: boolean;
  nft: NFT | undefined;
}) {
  const [memeLabNftsLoaded, setMemeLabNftsLoaded] = useState(false);
  const [memeLabNfts, setMemeLabNfts] = useState<NFT[]>([]);
  const [rememesTotalResults, setRememesTotalResults] = useState(0);
  const [rememesPage, setRememesPage] = useState(1);
  const [rememes, setRememes] = useState<Rememe[]>([]);
  const [showRememesSort, setShowRememesSort] = useState(false);
  const [rememesLoaded, setRememesLoaded] = useState(false);
  const rememesTarget = useRef<HTMLImageElement>(null);
  const rememeSorting = [RememeSort.RANDOM, RememeSort.CREATED_ASC];
  const [selectedRememeSorting, setSelectedRememeSorting] = useState<RememeSort>(RememeSort.RANDOM);
  useEffect(() => {
    if (props.nft) {
      fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts_memelab?sort_direction=asc&meme_id=${props.nft.id}`).then((response: DBResponse) => {
        setMemeLabNfts(response.data);
        setMemeLabNftsLoaded(true);
      });
    }
  }, [props.nft]);
  useEffect(() => {
    if (props.nft) {
      fetchRememes(props.nft.id);
    }
  }, [props.nft, rememesPage, selectedRememeSorting]);
  function fetchRememes(meme_id: number) {
    let sort = "";
    if (selectedRememeSorting === RememeSort.CREATED_ASC) {
      sort = "&sort=created_at&sort_direction=desc";
    }
    fetchUrl(`${publicEnv.API_ENDPOINT}/api/rememes?meme_id=${meme_id}&page_size=${REMEMES_PAGE_SIZE}&page=${rememesPage}${sort}`).then((response_0: DBResponse) => {
      setRememesTotalResults(response_0.count);
      setRememes(response_0.data);
      setShowRememesSort(response_0.count > REMEMES_PAGE_SIZE);
      setRememesLoaded(true);
    });
  }
  if (props.show) {
    return <>
        <Row className="pt-3">
          <Col>
            <Image unoptimized width="0" height="0" style={{
            width: "250px",
            height: "auto"
          }} src="/memelab.png" alt="memelab" />
          </Col>
        </Row>
        <Row className="pt-4 pb-2">
          <Col>
            The Meme Lab is the lab for Meme Artists to release work that is
            related to The Meme Cards.
          </Col>
        </Row>
        {printMemeReferences(memeLabNfts, "meme-lab", memeLabNftsLoaded, true)}
        <Row className="pt-3" ref={rememesTarget}>
          <Col className="d-flex flex-wrap align-items-center justify-content-between">
            <h1 className="mb-0 pt-2">
              <Image unoptimized width="0" height="0" style={{
              width: "250px",
              height: "auto",
              float: "left"
            }} src="/re-memes.png" alt="re-memes" />
            </h1>
            {showRememesSort && <span className="d-flex align-items-center gap-2 pt-2">
                <Dropdown className={styles["rememesSortDropdown"]} drop={"down-centered"}>
                  <Dropdown.Toggle>
                    Sort: {selectedRememeSorting}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {rememeSorting.map(s => <Dropdown.Item key={`sorting-${s}`} onClick={() => {
                  setRememesPage(1);
                  setRememesTotalResults(0);
                  setSelectedRememeSorting(s);
                }}>
                        {s}
                      </Dropdown.Item>)}
                  </Dropdown.Menu>
                </Dropdown>
                {selectedRememeSorting === RememeSort.RANDOM && <>
                    <FontAwesomeIcon icon={faRefresh} className={styles["buttonIcon"]} onClick={() => {
                if (props.nft) {
                  fetchRememes(props.nft.id);
                }
              }} data-tooltip-id="refresh-rememes" />
                    <Tooltip id="refresh-rememes" place="top" delayShow={250} style={{
                backgroundColor: "#f8f9fa",
                color: "#212529",
                padding: "4px 8px"
              }}>
                      Refresh results
                    </Tooltip>
                  </>}
              </span>}
          </Col>
        </Row>
        <Row className="pt-4 pb-2">
          <Col>
            ReMemes are community-created and community-submitted NFTs inspired
            by the Meme Cards. They are not created or &quot;authorized&quot; by
            6529 Collections.
          </Col>
        </Row>
        {rememesLoaded && rememes.length === 0 && <Row className="pt-2 pb-4">
            <Col>ReMemes that reference this NFT will appear here.</Col>
          </Row>}
        {rememes.length > 0 && <>
            <Row className="pt-2 pb-2">
              {rememes.map(rememe => {
            return <Col key={`${rememe.contract}-${rememe.id}`} className="pt-3 pb-3" xs={{
              span: 6
            }} sm={{
              span: 4
            }} md={{
              span: 3
            }} lg={{
              span: 3
            }}>
                    <Link href={`/rememes/${rememe.contract}/${rememe.id}`} className="decoration-none scale-hover">
                      <Container fluid className="no-padding">
                        <Row>
                          <Col>
                            <RememeImage nft={rememe} animation={false} height={300} />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Container>
                              <Row>
                                <Col className="font-smaller font-color-h d-flex justify-content-center align-items-center">
                                  {areEqualAddresses(rememe.contract, OPENSEA_STORE_FRONT_CONTRACT) ? <>
                                      {rememe.contract_opensea_data.collectionName}
                                    </> : <>
                                      {rememe.contract_opensea_data.collectionName ? rememe.contract_opensea_data.collectionName : formatAddress(rememe.contract)}{" "}
                                      #{rememe.id}
                                    </>}
                                  {rememe.replicas.length > 1 && <>
                                      &nbsp;(x
                                      {numberWithCommas(rememe.replicas.length)}
                                      )
                                    </>}
                                </Col>
                              </Row>
                              <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                  <span className="text-center">
                                    {rememe.metadata.name ? rememe.metadata.name : `${formatAddress(rememe.contract)} #${rememe.id}`}
                                  </span>
                                </Col>
                              </Row>
                            </Container>
                          </Col>
                        </Row>
                      </Container>
                    </Link>
                  </Col>;
          })}
            </Row>
            {rememesTotalResults > REMEMES_PAGE_SIZE && <Row className="text-center pt-2 pb-3">
                <Pagination page={rememesPage} pageSize={REMEMES_PAGE_SIZE} totalResults={rememesTotalResults} setPage={function (newPage: number) {
            setRememesPage(newPage);
            if (rememesTarget.current) {
              rememesTarget.current.scrollIntoView({
                behavior: "smooth"
              });
            }
          }} />
              </Row>}
          </>}
      </>;
  } else {
    return <></>;
  }
}